import React from "react";
import { useSelector } from "react-redux";
import "./Checkout.css";

const Checkout = () => {
  const state = useSelector((state) => state.handleCart);

  const total = state.reduce((sum, item) => sum + item.price, 0);

  const itemList = (item) => (
    <li
      className="list-group-item d-flex justify-content-between align-items-center border-0 bg-transparent"
      key={item.id}
    >
      <div className="d-flex align-items-center">
        <img src={item.image} alt={item.title} className="checkout-item-img me-3" />
        <h6 className="my-0">{item.title}</h6>
      </div>
      <span className="fw-bold text-primary">₹{item.price}</span>
    </li>
  );

  return (
    <div className="checkout-container py-5">
      <div className="container">
        <div className="row g-5">
          {/* Cart Summary */}
          <div className="col-md-5 col-lg-4 order-md-last">
            <div className="checkout-summary shadow-lg p-4 rounded-4">
              <h4 className="d-flex justify-content-between align-items-center mb-3">
                <span className="fw-bold text-dark">Your Cart</span>
                <span className="badge bg-success rounded-pill">{state.length}</span>
              </h4>

              <ul className="list-group mb-3">
                {state.map(itemList)}
                <li className="list-group-item d-flex justify-content-between fw-bold border-0 bg-transparent mt-2">
                  <span>Total</span>
                  <span>₹{total.toFixed(2)}</span>
                </li>
              </ul>

              <div className="input-group mt-3">
                <input
                  type="text"
                  className="form-control promo-input"
                  placeholder="Promo code"
                />
                <button type="button" className="btn btn-primary">
                  Redeem
                </button>
              </div>
            </div>
          </div>

          <div className="col-md-7 col-lg-8">
            <div className="checkout-form shadow-lg p-4 rounded-4">
              <h4 className="mb-4 fw-bold">Billing Details</h4>
              <form>
                <div className="row g-3">
                  <div className="col-sm-6">
                    <label className="form-label">First name</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-sm-6">
                    <label className="form-label">Last name</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Email</label>
                    <input type="email" className="form-control modern-input" />
                  </div>
                  <div className="col-12">
                    <label className="form-label">Address</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">State</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Zip</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                </div>

                <hr className="my-4" />
                <h4 className="mb-3 fw-bold">Payment</h4>
                <div className="my-3">
                  <div className="form-check">
                    <input
                      type="radio"
                      name="paymentMethod"
                      className="form-check-input"
                      defaultChecked
                    />
                    <label className="form-check-label">Credit card</label>
                  </div>
                  <div className="form-check">
                    <input
                      type="radio"
                      name="paymentMethod"
                      className="form-check-input"
                    />
                    <label className="form-check-label">PayPal</label>
                  </div>
                </div>

                <div className="row gy-3">
                  <div className="col-md-6">
                    <label className="form-label">Card Name</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Card Number</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Expiration</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">CVV</label>
                    <input type="text" className="form-control modern-input" />
                  </div>
                </div>

                <button className="btn btn-success w-100 mt-4 checkout-btn" type="submit">
                  Complete Checkout
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;
